import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, shareReplay, switchMap, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshInProgress?: Observable<{ access_token: string }>;

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If JSONP, no auth
    if (request.method === 'JSONP') {
      return next.handle(request);
    }

    if (this.isRefreshRequest(request)) {
      return next.handle(request);
    }

    const accessToken = localStorage.getItem('access_token');
    const clonedRequest = accessToken ? this.addAuthHeader(request, accessToken) : request;

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 401) {
          return throwError(() => error);
        }

        return this.handle401Error(request, next);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshInProgress = this.authService.refreshAccessToken().pipe(
        tap((tokenResponse: { access_token: string }) => {
          this.authService.updateAccessToken(tokenResponse.access_token);
        }),
        finalize(() => {
          this.isRefreshing = false;
          this.refreshInProgress = undefined;
        }),
        shareReplay(1)
      );
    }

    return this.refreshInProgress!.pipe(
      switchMap((tokenResponse: { access_token: string }) =>
        next.handle(this.addAuthHeader(request, tokenResponse.access_token))
      ),
      catchError(refreshError => {
        this.authService.logout();
        return throwError(() => refreshError);
      })
    );
  }

  private addAuthHeader(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  private isRefreshRequest(request: HttpRequest<any>): boolean {
    return request.url.includes('/api/refresh_token.php');
  }
}


// import { Injectable } from '@angular/core';
// import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
// import { Observable } from 'rxjs';

// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     if (request.method === 'JSONP') {
//       return next.handle(request);
//     }

//     const accessToken = localStorage.getItem('access_token');
//     if (accessToken) {
//       request = request.clone({
//         setHeaders: {
//           Authorization: `Bearer ${accessToken}`,
//         },
//       });
//     }
//     return next.handle(request);
//   }
// }
